import Swal from 'sweetalert2'
import * as Colors from '../../../common/colors'

export function SwalConfirmDanger({ titleText = '',text='', cancelButtonText = 'Cancelar', confirmButtonText = 'Si, reemplazar', showConfirmButton = true}) {
  return (dispatch) => {
    return Swal.fire({
      titleText,
      text,
      confirmButtonColor: Colors.COLOR_PRIMARIO ,
      cancelButtonColor: Colors.COLOR_TERCIARIO_DARK,
      showCancelButton: true,
      allowEnterKey: false,
      focusCancel: true,
      cancelButtonText,
      reverseButtons: true,
      confirmButtonText,
      allowOutsideClick: false,
      showConfirmButton
    }).then((res) => {
      if (res.value) {
        dispatch({
          type: 'CONFIRMATION_SWAL_DANGER',
          titleText,
        })
        return res.value
      }
      dispatch({
        type: 'CANCEL_SWAL_DANGER',
        titleText,
      })
      return res.value
    })
  }
}

export function SwalInfo ({titleText=''}){
  return (dispatch) => {
    return Swal.fire({
      text: titleText,
      confirmButtonColor: Colors.COLOR_PRIMARIO,
    }).then(res => {
      if (res.value) {
        dispatch({
          type: 'CONFIRMATION_SWAL',
          titleText,
        })
        return res.value
      }
    })
  }
}
